(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__hlnHoverVideoInjectorLoaded) return;
  window.__hlnHoverVideoInjectorLoaded = true;
  var MAX_CONCURRENT_VIDEOS = 3;
  var VIDEO_DWELL_MS = 1300;
  var mobileMql = window.matchMedia('(max-width: 767px)');
  var reducedMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');
  var eligibleVideos = new Map();
  var playingVideos = new Set();
  var hlnVideoObserver = null;
  var enforceVideoLimitTimer = null;
  var DEBOUNCE_MS = 400;
  var MAX_BATCH_SIZE = 60;
  var MAX_REQUESTS_PER_PAGEVIEW = 20;
  var FETCH_TIMEOUT_MS = 8000;
  var pendingHandles = new Set();
  var pendingCards = new Map();
  var debounceTimer = null;
  var fetchInFlight = false;
  var requestCount = 0;
  var STOREFRONT_QUERY = 'query HlnVideoBatch($q: String!, $first: Int!) { products(first: $first, query: $q) { nodes { handle media(first: 5) { nodes { mediaContentType ... on Video { sources { url mimeType } previewImage { url(transform: {maxWidth: 450}) } } } } metafield(namespace: "custom", key: "video") { reference { ... on Video { sources { url mimeType } previewImage { url(transform: {maxWidth: 450}) } } } } } } }';
  function isMobile() { return mobileMql.matches; }
  function prefersReducedMotion() { return reducedMotionMql.matches; }
  function playVideo(video) { video.setAttribute('autoplay', ''); video.style.opacity = '1'; var p = video.play(); if (p !== undefined) p.catch(function () {}); playingVideos.add(video); }
  function pauseVideo(video) { video.style.opacity = '0'; video.pause(); playingVideos.delete(video); }
  function enforceVideoLimit() {
    var now = Date.now(); var entries = [];
    eligibleVideos.forEach(function (visibleSince, video) { if (isMobile() && now - visibleSince < VIDEO_DWELL_MS) return; entries.push([video, visibleSince]); });
    entries.sort(function (a, b) { return b[1] - a[1]; });
    var toPlay = entries.slice(0, MAX_CONCURRENT_VIDEOS).map(function (e) { return e[0]; });
    entries.forEach(function (entry) { var video = entry[0]; if (toPlay.indexOf(video) !== -1) { if (!playingVideos.has(video)) playVideo(video); } else if (playingVideos.has(video)) { pauseVideo(video); } });
  }
  function getVideoObserver() {
    if (hlnVideoObserver) return hlnVideoObserver;
    hlnVideoObserver = new IntersectionObserver(function (entries) {
      if (!isMobile()) return;
      entries.forEach(function (entry) {
        var video = entry.target; var visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (prefersReducedMotion()) { video.style.opacity = visible ? '1' : '0'; eligibleVideos.delete(video); if (playingVideos.has(video)) pauseVideo(video); return; }
        if (visible) { if (!eligibleVideos.has(video)) eligibleVideos.set(video, Date.now()); } else { eligibleVideos.delete(video); if (playingVideos.has(video)) pauseVideo(video); }
      });
      clearTimeout(enforceVideoLimitTimer); enforceVideoLimitTimer = setTimeout(enforceVideoLimit, VIDEO_DWELL_MS);
    }, { threshold: [0, 0.5, 1] });
    return hlnVideoObserver;
  }
  function observeVideo(video) { if (!video || video.dataset.hlnObserved) return; video.dataset.hlnObserved = '1'; if (!video.hasAttribute('playsinline')) video.setAttribute('playsinline', ''); getVideoObserver().observe(video); }
  if (mobileMql.addEventListener) { mobileMql.addEventListener('change', function () { if (!isMobile()) { eligibleVideos.forEach(function (visibleSince, video) { pauseVideo(video); }); eligibleVideos.clear(); } }); }
  function buildVideo(data) {
    var holder = document.createElement('div'); holder.className = 'nodus-injected-video-holder'; holder.style.cssText = 'position:absolute;inset:0;pointer-events:none;';
    var video = document.createElement('video'); video.className = 'nodus-hover-video'; video.loop = true; video.muted = true; video.playsInline = true; video.preload = 'metadata';
    if (data.poster) video.poster = data.poster;
    video.style.cssText = 'object-fit:cover;width:100%;height:100%;position:absolute;top:0;left:0;opacity:0;transition:opacity .3s ease;z-index:10;pointer-events:none;';
    var source = document.createElement('source'); source.src = data.src; source.type = 'video/mp4'; video.appendChild(source); holder.appendChild(video);
    return { holder: holder, video: video };
  }
  function injectVideoIntoCard(card, data) {
    if (card.querySelector('video.nodus-hover-video')) return;
    var wrapper = card.querySelector('.product-card__image-wrapper, .spf-product-card__image-wrapper'); if (!wrapper) return;
    if (window.getComputedStyle(wrapper).position === 'static') wrapper.style.position = 'relative';
    var built = buildVideo(data); wrapper.appendChild(built.holder);
    wrapper.addEventListener('mouseenter', function () { built.video.style.opacity = '1'; var p = built.video.play(); if (p !== undefined) p.catch(function () {}); });
    wrapper.addEventListener('mouseleave', function () { built.video.style.opacity = '0'; built.video.pause(); });
    observeVideo(built.video);
  }
  function queueHandle(handle, card) { pendingHandles.add(handle); if (!pendingCards.has(handle)) pendingCards.set(handle, []); pendingCards.get(handle).push(card); scheduleFlush(); }
  function scheduleFlush() { if (debounceTimer) clearTimeout(debounceTimer); debounceTimer = setTimeout(flushQueue, DEBOUNCE_MS); }
  function flushQueue() {
    debounceTimer = null; if (pendingHandles.size === 0) return;
    if (fetchInFlight) { scheduleFlush(); return; }
    if (requestCount >= MAX_REQUESTS_PER_PAGEVIEW) { pendingHandles.clear(); pendingCards.clear(); return; }
    var handles = Array.prototype.slice.call(pendingHandles).slice(0, MAX_BATCH_SIZE);
    handles.forEach(function (h) { pendingHandles.delete(h); });
    fetchInFlight = true; requestCount += 1;
    fetchVideoBatch(handles).catch(function () {}).then(function () { fetchInFlight = false; if (pendingHandles.size > 0) scheduleFlush(); });
  }
  function fetchVideoBatch(handles) {
    var cfg = window.__hlnStorefrontCfg; if (!cfg || !cfg.token || !cfg.shop) return Promise.resolve();
    var queryStr = handles.map(function (h) { return "handle:'" + String(h).replace(/'/g, '') + "'"; }).join(' OR ');
    var endpoint = 'https://' + cfg.shop + '/api/' + (cfg.apiVersion || '2024-10') + '/graphql.json';
    var controller = window.AbortController ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS) : null;
    return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token }, body: JSON.stringify({ query: STOREFRONT_QUERY, variables: { q: queryStr, first: handles.length } }), signal: controller ? controller.signal : undefined })
      .then(function (res) { if (timeoutId) clearTimeout(timeoutId); if (!res.ok) throw new Error('storefront http ' + res.status); return res.json(); })
      .then(function (json) {
        var nodes = json && json.data && json.data.products && json.data.products.nodes; var found = {};
        if (nodes) { nodes.forEach(function (node) { found[node.handle] = true; var data = extractVideoData(node); if (data) { window.__hlnVideoMap = window.__hlnVideoMap || {}; window.__hlnVideoMap[node.handle] = data; injectForHandle(node.handle, data); } else { pendingCards.delete(node.handle); } }); }
        handles.forEach(function (h) { if (!found[h]) pendingCards.delete(h); });
      })
      .catch(function () { if (timeoutId) clearTimeout(timeoutId); handles.forEach(function (h) { pendingCards.delete(h); }); });
  }
  function extractVideoData(node) {
    var mediaVideo = null;
    if (node.media && node.media.nodes) { for (var i = 0; i < node.media.nodes.length; i++) { var m = node.media.nodes[i]; if (m.mediaContentType === 'VIDEO' && m.sources && m.sources.length) { mediaVideo = m; break; } } }
    var videoObj = mediaVideo || (node.metafield && node.metafield.reference); if (!videoObj || !videoObj.sources || !videoObj.sources.length) return null;
    var mp4 = null; for (var j = 0; j < videoObj.sources.length; j++) { if (videoObj.sources[j].mimeType === 'video/mp4') { mp4 = videoObj.sources[j]; break; } }
    var src = (mp4 || videoObj.sources[0]).url; if (!src) return null;
    var poster = videoObj.previewImage ? videoObj.previewImage.url : ''; return { src: src, poster: poster };
  }
  function injectForHandle(handle, data) { var cards = pendingCards.get(handle) || []; pendingCards.delete(handle); cards.forEach(function (card) { if (!card.isConnected) return; injectVideoIntoCard(card, data); }); }
  function attach(card) {
    if (!card || card.nodeType !== 1 || card.dataset.hlnVideoScan) return; card.dataset.hlnVideoScan = '1';
    var existingVideo = card.querySelector('video.nodus-hover-video'); if (existingVideo) { observeVideo(existingVideo); return; }
    var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
    var href = link.getAttribute('href') || ''; var m = href.match(/\/products\/([^/?#]+)/); if (!m) return;
    var handle = decodeURIComponent(m[1]); var map = window.__hlnVideoMap || {}; var data = map[handle];
    if (data && data.src) { injectVideoIntoCard(card, data); return; }
    queueHandle(handle, card);
  }
  function scan(root) { var scope = root || document; if (scope.querySelectorAll) { scope.querySelectorAll('.product-card, .spf-product-card').forEach(attach); } }
  function start() {
    scan(); var target = document.body; if (!target) return;
    var mo = new MutationObserver(function (mutations) { mutations.forEach(function (mutation) { mutation.addedNodes.forEach(function (node) { if (node.nodeType !== 1) return; if (node.matches && (node.matches('.product-card') || node.matches('.spf-product-card'))) { attach(node); } scan(node); }); }); });
    mo.observe(target, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
  } catch(e) { console.error(e); }
})();

})();
